import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import "./help.scss";
import Header from "../../components/header/header";
import Image from "../../components/image/image";
import NextIcon from "../../assets/backIcon.svg";
import {pageUrl} from "../../utils/pageConstant";

const Help = () => {
  const navigate = useNavigate();
  const walletReward = useSelector((state) => state.wallet.coins);

  const handleBack = () => {
    // navigate(pageUrl.EXPLORE);
    navigate("/profile");
  };

  const handleNext = () => {
    navigate(pageUrl.GENERAL_ENQUIRY);
  };

  const handleQuery = () => {
    navigate(pageUrl.RAISED_QUERY);
  };

  return (
    <div className="help-page">
      <Header coin={walletReward} onClick={handleBack} label="Help" />
      <label className="title">Help Topics</label>
      <div className="help-options">
        <div className="enquiry" onClick={handleNext}>
          <span>General Enquiry</span>
          <Image src={NextIcon} className="copon-code-icon" alt="coupon code" />
        </div>
        {/* <div className="enquiry">
          <span>Query related to bill</span>
          <Image src={NextIcon} className="copon-code-icon" alt="coupon code" />
        </div>
        <div className="enquiry">
          <span>Query related to Restaurant</span>
          <Image src={NextIcon} className="copon-code-icon" alt="coupon code" />
        </div> */}
        <div className="query" onClick={handleQuery}>
          <span>Raised Query</span>
          <Image src={NextIcon} className="copon-code-icon" alt="coupon code" />
        </div>
      </div>
    </div>
  );
};

export default Help;
